import { PostFormValues } from '../../../app/models/post'

export type CoverImageMode = 'url' | 'upload';

const STORAGE_KEY = 'gunslop_post_draft'
/** Survives PostForm remount when the route `key` changes after `history.replace`. */
const RESUME_BOOTSTRAP_KEY = 'gunslop_post_draft_active'

type SerializedPostDraftV1 = {
  v: 1;
  post: PostFormValues;
  coverImageMode: CoverImageMode;
};

export type LoadedPostDraft = {
  values: PostFormValues;
  coverImageMode: CoverImageMode;
};

export type PostResumeBootstrapV1 = {
  v: 1;
  formValues: PostFormValues;
  coverImageMode: CoverImageMode;
  submitAfterRestore: boolean;
  linkedModelOption?: { value: string; label: string };
  resumeNotice: 'success' | 'warning' | 'none';
};

export function saveDraft (values: PostFormValues, coverImageMode: CoverImageMode): void {
  const payload: SerializedPostDraftV1 = {
    v: 1,
    post: {
      ...values,
      tags: values.tags ?? []
    },
    coverImageMode
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
}

export function loadDraft (): LoadedPostDraft | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as SerializedPostDraftV1
    if (parsed?.v !== 1 || !parsed.post || typeof parsed.post !== 'object') return null
    return {
      values: new PostFormValues(parsed.post as PostFormValues),
      coverImageMode:
        parsed.coverImageMode === 'upload' || parsed.coverImageMode === 'url'
          ? parsed.coverImageMode
          : 'url'
    }
  } catch {
    return null
  }
}

export function clearDraft (): void {
  sessionStorage.removeItem(STORAGE_KEY)
}

export function writeResumeBootstrap (payload: Omit<PostResumeBootstrapV1, 'v'>): void {
  const full: PostResumeBootstrapV1 = { v: 1, ...payload }
  sessionStorage.setItem(RESUME_BOOTSTRAP_KEY, JSON.stringify(full))
}

export function readResumeBootstrap (): PostResumeBootstrapV1 | null {
  try {
    const raw = sessionStorage.getItem(RESUME_BOOTSTRAP_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as PostResumeBootstrapV1
    sessionStorage.removeItem(RESUME_BOOTSTRAP_KEY)
    if (parsed?.v !== 1 || !parsed.formValues) return null
    return {
      ...parsed,
      formValues: new PostFormValues(parsed.formValues as PostFormValues)
    }
  } catch {
    sessionStorage.removeItem(RESUME_BOOTSTRAP_KEY)
    return null
  }
}
